<!-- chat-floating.component.html -->

<!-- Botón flotante -->
<div class="chat-fab" (click)="toggleChat()" [class.active]="isOpen">
    <i *ngIf="!isOpen" class="bi bi-chat-dots-fill"></i>
    <i *ngIf="isOpen" class="bi bi-x-lg"></i>
  </div>

  <!-- Ventana de chat -->
  <div class="chat-window" [class.open]="isOpen">

    <!-- Header -->
    <div class="chat-header">
      <div class="header-info">
        <i class="bi bi-clock"></i>
        <span>{{ now | date:'HH:mm' }} hs</span>
      </div>
      <div class="header-right">

        <button (click)="toggleChat()" class="close-btn">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <!-- Mensajes -->
    <div class="chat-messages" #messagesContainer>
      <!-- Estado vacío -->
      <div *ngIf="messages.length === 0" class="empty-state">
        <div class="agent-avatar">
          <img *ngIf="!avatarError" [src]="avatarUrl" alt="Sofi" (error)="avatarError = true" />
          <i *ngIf="avatarError" class="bi bi-person-fill"></i>
        </div>
        <h3>Hola soy Sofi</h3>
        <hr />
        <p>¿En qué te puedo ayudar?</p>
        <!-- <div class="quick-suggestions">
          <button (click)="sendQuickSuggestion('¿Cómo funciona la plataforma?')">¿Cómo funciona?</button>
          <button (click)="sendQuickSuggestion('¿Qué servicios ofrecen?')">Servicios</button>
          <button (click)="sendQuickSuggestion('Necesito ayuda con mi reserva')">Ayuda con reserva</button>
        </div> -->
      </div>

      <!-- Mensajes -->
      <div *ngFor="let msg of messages" class="message" [class.user]="msg.sender === 'user'">
        <div class="avatar">
          <ng-container *ngIf="msg.sender === 'bot'">
            <img *ngIf="!avatarError" [src]="avatarUrl" alt="Sofi" (error)="avatarError = true" />
            <i *ngIf="avatarError" class="bi bi-person-fill"></i>
          </ng-container>
          <i *ngIf="msg.sender === 'user'" class="bi bi-person"></i>
        </div>
        <div class="bubble">
          <div *ngIf="msg.attachments?.length" class="msg-attachments">
            <ng-container *ngFor="let att of msg.attachments">
              <!-- Con URL (sesión actual): preview real -->
              <ng-container *ngIf="att.url; else attChip">
                <a *ngIf="att.kind === 'image'" class="msg-media" [href]="att.url" target="_blank" rel="noopener">
                  <img [src]="att.url" [alt]="att.name" />
                </a>
                <video *ngIf="att.kind === 'video'" class="msg-media" [src]="att.url" controls preload="metadata"></video>
                <a *ngIf="att.kind === 'pdf'" class="file-chip" [href]="att.url" target="_blank" rel="noopener">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                  <span class="file-name">{{ att.name }}</span>
                  <small>{{ formatSize(att.size) }}</small>
                </a>
              </ng-container>
              <!-- Historial recargado: solo nombre y tipo -->
              <ng-template #attChip>
                <div class="file-chip">
                  <i class="bi" [ngClass]="att.kind === 'image' ? 'bi-file-earmark-image' : att.kind === 'video' ? 'bi-file-earmark-play' : 'bi-file-earmark-pdf-fill'"></i>
                  <span class="file-name">{{ att.name }}</span>
                  <small>{{ formatSize(att.size) }}</small>
                </div>
              </ng-template>
            </ng-container>
          </div>
          {{ msg.text }}
          <div *ngIf="msg.isLoading" class="typing">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Input -->
    <div class="chat-input">
      <div *ngIf="attachError" class="attach-error">
        <i class="bi bi-exclamation-circle"></i> {{ attachError }}
      </div>

      <!-- Adjuntos pendientes -->
      <div *ngIf="pendingAttachments.length" class="pending-attachments">
        <div *ngFor="let att of pendingAttachments; let i = index" class="pending-item" [title]="att.name">
          <img *ngIf="att.kind === 'image'" [src]="att.url" [alt]="att.name" />
          <ng-container *ngIf="att.kind === 'video'">
            <video [src]="att.url" muted preload="metadata"></video>
            <i class="bi bi-play-fill overlay-icon"></i>
          </ng-container>
          <div *ngIf="att.kind === 'pdf'" class="pdf-thumb">
            <i class="bi bi-file-earmark-pdf-fill"></i>
            <span>{{ att.name }}</span>
          </div>
          <button type="button" class="remove-btn" (click)="removeAttachment(i)" title="Quitar">
            <i class="bi bi-x"></i>
          </button>
        </div>
      </div>

      <input
        #fileInput
        type="file"
        hidden
        multiple
        accept="image/*,video/*,application/pdf"
        (change)="onFilesSelected($event)"
      />
      <div class="input-pill">
        <button type="button" class="attach-btn" title="Adjuntar imagen, video o PDF" (click)="openFilePicker()" [disabled]="isLoading">
          <i class="bi bi-paperclip"></i>
        </button>
        <input
          [(ngModel)]="newMessage"
          (keydown.enter)="sendMessage()"
          placeholder="Escribí tu mensaje..."
          [disabled]="isLoading"
        />
        <button class="send-btn" (click)="sendMessage()" [disabled]="(!newMessage.trim() && !pendingAttachments.length) || isLoading">
          <i class="bi bi-send-fill"></i>
        </button>
      </div>
    </div>
  </div>
